import React from "react";
import { Image } from "antd";
import { useAuth } from "../Auth/Auth";
import { httpForBlob } from "../Common/http";
import { isIOS } from "react-device-detect";
import { ApplyDocumentViewItem } from "./ApplyDocumentDrawer";
import { Document, Page, pdfjs } from "react-pdf";
import { front_server } from "../Common/AppSettings";
import { SizeMe } from "react-sizeme";
pdfjs.GlobalWorkerOptions.workerSrc = `${front_server}/pdf.worker.min.js`;

interface Props {
  viewDocument: ApplyDocumentViewItem;
  isScoringPage?: boolean;
}

export const ApplyDocumentView = ({ viewDocument, isScoringPage }: Props) => {
  const { accessToken } = useAuth();
  const [view, setView] = React.useState<any>(<div>loading...</div>);
  const [numPages, setNumPages] = React.useState(null);
  // const pdfViewRef = useRef(null);
  // const [pageNumber, setPageNumber] = React.useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    // console.log(numPages);
    setNumPages(numPages);
  };

  React.useEffect(() => {
    const doCreateDocumentView = async () => {
      const result = await httpForBlob<{
        DocumentCategory: string;
        DocumentFileId: string;
        DocumentTypeCode: string;
      }>({
        path: "/ApplyDocument/getdocument",
        method: "post",
        body: {
          DocumentCategory: viewDocument.documentCategory,
          DocumentFileId: viewDocument.documentFileId,
          DocumentTypeCode: viewDocument.documentTypeCode,
        },
        accessToken: accessToken,
      });
      if (result.size > 0) {
        if (viewDocument.documentTypeCode === "01") {
          // var userAgent = window.navigator.userAgent;
          if (isIOS) {
            result.arrayBuffer().then((buffer) => {
              setView(
                <div
                  className={
                    isScoringPage
                      ? "all-page-container-scoring"
                      : "all-page-container"
                  }
                >
                  <SizeMe>
                    {({ size }) => (
                      <Document
                        file={buffer}
                        onLoadSuccess={onDocumentLoadSuccess}
                        options={{
                          cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
                          cMapPacked: true,
                        }}
                      >
                        {Array.apply(null, Array(numPages))
                          .map((x, i) => i + 1)
                          .map((page) => (
                            <Page
                              pageNumber={page}
                              width={size.width ? size.width : 1}
                            />
                          ))}
                      </Document>
                    )}
                  </SizeMe>
                </div>
              );
            });
          } else {
            const urlPdf = window.URL.createObjectURL(result);

            const view = (
              <div>
                <iframe
                  // ref={pdfViewRef}
                  id="pdfFrame"
                  title="pdf"
                  src={`${urlPdf}`}
                  style={{ width: "100%", height: "calc(100vh - 180px)" }}
                ></iframe>
              </div>
            );
            setView(view);
          }
        } else if (viewDocument.documentTypeCode === "02") {
          const reader = new FileReader();
          reader.readAsText(result);
          reader.onload = function (event) {
            setView(
              <div
                style={{
                  width: "100%",
                  whiteSpace: "pre-wrap",
                }}
              >
                {event.target?.result}
              </div>
            );
          };
        } else {
          const urlImage = window.URL.createObjectURL(result);
          setView(
            <div>
              <Image style={{ width: "100%" }} src={urlImage} />
            </div>
          );
        }
      } else {
        // console.error("download error!");
        setView(<div>書類ファイルの取得に失敗しました。</div>);
      }
    };
    if (viewDocument) {
      doCreateDocumentView();
      // const el2: any = pdfViewRef.current;
      // if (el2 && el2 != null) {
      //   console.log(el2);
      //   el2.contentWindow.eval(
      //     'document.addEventListener("contextmenu", function (e) {e.preventDefault();}, false)'
      //   );
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewDocument, isScoringPage, numPages]);

  return view;
};
